import {
  computed,
  inject,
  Injectable,
  resource,
  ResourceRef,
  Signal,
} from '@angular/core';
import { CONFIGURATION_SETTING_KEYS, IHusstSortGroup } from '@web/dtos';
import { SortGroupsGateway } from './sort-groups.gateway';
import { IApiResponse } from '@web/shared-types';
import { firstValueFrom } from 'rxjs';
import { ConfigurationStore } from '../configuration/configuration-store.service';

@Injectable({ providedIn: 'root' })
export class SortGroupsStore {
  private readonly gateway: SortGroupsGateway = new SortGroupsGateway();
  private readonly configurationStore = inject(ConfigurationStore);
  private readonly serviceAreaId = computed(() =>
    this.configurationStore.getNumberConfiguration(
      CONFIGURATION_SETTING_KEYS.ServiceAreaId
    )
  );

  #sortGroupsResource: ResourceRef<
    IApiResponse<IHusstSortGroup[]> | undefined
  > = resource({
    params: computed(() => ({
      serviceAreaId: this.serviceAreaId(),
    })),
    loader: ({ params }) =>
      firstValueFrom(
        this.gateway.list('VerkaufssortengruppeRelation', params.serviceAreaId)
      ),
  });

  public readonly isLoading: Signal<boolean> = computed(() =>
    this.#sortGroupsResource.isLoading()
  );
  public readonly sortGroups: Signal<IHusstSortGroup[]> = computed(() =>
    this.#sortGroupsResource.hasValue()
      ? (this.#sortGroupsResource.value()?.data ?? [])
      : []
  );
}
